import { render, staticRenderFns } from "./WjManage.vue?vue&type=template&id=5dc44f98&scoped=true&"
import script from "./WjManage.vue?vue&type=script&lang=js&"
export * from "./WjManage.vue?vue&type=script&lang=js&"
import style0 from "./WjManage.vue?vue&type=style&index=0&id=5dc44f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc44f98",
  null
  
)

export default component.exports